module.exports = __webpack_public_path__ + "img/prototype.d748d166.svg";